import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'

/**
 * Per-company terminology for the field worker.
 *
 * A company can rename "Technician" to whatever fits its trade (a cleaning
 * company uses "Cleaner"). The noun comes from the current domain
 * (auth store -> domain.worker_term_singular/plural) and falls back to
 * Technician/Technicians so every existing company is unchanged.
 *
 * Usage:
 *   const { term, termPlural, termLower } = useWorkerTerm()
 *   `Select a ${termLower.value}`   // "Select a cleaner"
 */
export function useWorkerTerm() {
  const auth = useAuthStore()

  const term = computed(() => auth.workerTerm || 'Technician')
  const termPlural = computed(() => auth.workerTermPlural || 'Technicians')
  const termLower = computed(() => term.value.toLowerCase())
  const termPluralLower = computed(() => termPlural.value.toLowerCase())

  return { term, termPlural, termLower, termPluralLower }
}

export default useWorkerTerm
